import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ngb-notification-messages-edit-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{name}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
          <label for="alertType">Alert Type:</label>
          <input type="text" class="form-control" id="alertType" aria-describedby="alertType" value={{message.type}} [attr.disabled]="message.type ? '': null" />
        </div>
        <fieldset class="p-2" style="width:90%; margin-left:30px; border:1px solid #7c7d7d!important;">
          <legend class="w-auto" style="font-size:1.2rem;">{{legend1}} Message</legend>
          <div class="form-group">
          <label for="InputStartSubject">Subject:</label>
          <input type="text" class="form-control" id="InputStartSubject" aria-describedby="startSubjectHelp" placeholder="Subject" value={{message.startSubject}}>
        </div>
        <div class="form-group">
          <label for="InputStartBody">Body:</label>
          <textarea rows="2" cols="50"  class="form-control" id="InputStartBody" placeholder="Body" value={{message.startBody}}></textarea>
        </div>
        <div style="margin-top:26px; margin-bottom: 5px;">
          <div class="btn-group">
            <button style="min-width:100px;">Save {{legend1}} Message</button>
          </div>
        </div>
        </fieldset>
        &nbsp;
        <fieldset class="p-2" style="width:90%; margin-left:30px; border:1px solid #7c7d7d!important;">
          <legend class="w-auto" style="font-size:1.2rem;">{{legend2}} Message</legend>
          <div class="form-group">
            <label for="InputStopSubject">Subject:</label>
            <input type="text" class="form-control" id="InputStopSubject" aria-describedby="stopSubjectHelp" placeholder="Subject" value={{message.stopSubject}}>
          </div>
          <div class="form-group">
            <label for="InputStopBody">Body:</label>
            <textarea rows="2" cols="50"  class="form-control" id="InputStopBody" placeholder="Body" value={{message.stopBody}}></textarea>
          </div>
            <div style="margin-top:26px; margin-bottom: 5px;">
              <div class="btn-group">
              <button style="min-width:100px;">Save {{legend2}} Message</button>
            </div>
          </div>
        </fieldset>
      </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Close</button>
    </div>  `
})
export class NgbNotificationMessagesEditComponent {
  @Input() name;
  @Input() legend1;
  @Input() legend2;
  @Input() message;

  constructor(public activeModal: NgbActiveModal) { }
}
